module.exports = __webpack_public_path__ + "fonts/agatho-webfont.405f8304.woff2";